var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "booking-section",
    { attrs: { id: "leadForm", title: `Ihr Reiseangebot`, contentClass: "" } },
    [
      _vm.loaded
        ? [
            _c("div", { staticClass: "booking-element" }, [
              _c("h3", [_vm._v(_vm._s(_vm.productName))]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column small-12 large-8" }, [
                  _c("div", {
                    staticClass: "spacer",
                    domProps: { innerHTML: _vm._s(_vm.introText) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "column small-12 large-6" }, [
                      _c(
                        "a",
                        {
                          staticClass: "cta cta--dark cta--inline",
                          on: {
                            click: function ($event) {
                              return _vm.sendBookingProceed()
                            },
                          },
                        },
                        [_vm._v("Direkt verbindlich buchen")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column small-12 large-6" }, [
                      _c(
                        "a",
                        {
                          staticClass: "cta cta--inline",
                          on: {
                            click: function ($event) {
                              return _vm.customerChoiceOffer()
                            },
                          },
                        },
                        [_vm._v("Unverbindlich reservieren")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column small-12 large-4" }, [
                  _c("img", { attrs: { src: _vm.introPicture } }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.offerMode
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      class: { "booking-error": _vm.hasErrors },
                    },
                    [
                      _c("label", [_c("b", [_vm._v("Ihre Daten")])]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "column small-12 large-2" },
                          [
                            _c("label", [_vm._v("Anrede")]),
                            _vm._v(" "),
                            _c("select2", {
                              attrs: {
                                options: _vm.genderSelect,
                                settings: {
                                  placeholder: "Bitte wählen Sie:",
                                  dropdownCssClass: "dropdown-shadow",
                                },
                              },
                              model: {
                                value: _vm.form.gender,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "gender", $$v)
                                },
                                expression: "form.gender",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12 large-5" },
                          [
                            _c("label", [_vm._v("Vorname*")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.first_name,
                                  expression: "form.first_name",
                                },
                              ],
                              staticClass: "underline",
                              attrs: { type: "text" },
                              domProps: { value: _vm.form.first_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "first_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors["first_name"], function (msg) {
                              return _vm.errors["first_name"]
                                ? _c("booking-element-error", {
                                    key: _vm.i,
                                    attrs: { type: "error", msg: msg },
                                  })
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12 large-5" },
                          [
                            _c("label", [_vm._v("Nachname*")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.last_name,
                                  expression: "form.last_name",
                                },
                              ],
                              staticClass: "underline",
                              attrs: { type: "text" },
                              domProps: { value: _vm.form.last_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "last_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors["last_name"], function (msg) {
                              return _vm.errors["last_name"]
                                ? _c("booking-element-error", {
                                    key: _vm.i,
                                    attrs: { type: "error", msg: msg },
                                  })
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12 large-4" },
                          [
                            _c("label", [_vm._v("E-Mail*")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.email,
                                  expression: "form.email",
                                },
                              ],
                              staticClass: "underline",
                              attrs: { type: "text" },
                              domProps: { value: _vm.form.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "email",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors["email"], function (msg) {
                              return _vm.errors["email"]
                                ? _c("booking-element-error", {
                                    key: _vm.i,
                                    attrs: { type: "error", msg: msg },
                                  })
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12 large-4" },
                          [
                            _c("label", [_vm._v("Telefonnummer*")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.phone,
                                  expression: "form.phone",
                                },
                              ],
                              staticClass: "underline",
                              attrs: { type: "text" },
                              domProps: { value: _vm.form.phone },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "phone",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors["phone"], function (msg) {
                              return _vm.errors["phone"]
                                ? _c("booking-element-error", {
                                    key: _vm.i,
                                    attrs: { type: "error", msg: msg },
                                  })
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "column small-12 large-4" }, [
                          _c("label", [_vm._v("Ort")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.city,
                                expression: "form.city",
                              },
                            ],
                            staticClass: "underline",
                            attrs: { type: "text" },
                            domProps: { value: _vm.form.city },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(_vm.form, "city", $event.target.value)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      class: { "booking-error": _vm.hasErrors },
                    },
                    [
                      _c("label", [
                        _c("b", [_vm._v("Rückrufbitte/Kontaktaufname")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "column small-12 large-4" },
                          [
                            _c("label", [_vm._v("Rückrufbitte:")]),
                            _vm._v(" "),
                            _c("select2", {
                              attrs: {
                                options: [
                                  { id: 0, text: "schnellstmöglich" },
                                  { id: 1, text: "Gewünschter Zeitraum" },
                                ],
                                settings: {
                                  placeholder: "Bitte wählen Sie:",
                                  dropdownCssClass: "dropdown-shadow",
                                },
                              },
                              model: {
                                value: _vm.form.callback_time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "callback_time", $$v)
                                },
                                expression: "form.callback_time",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors["callback_time"], function (msg) {
                              return _vm.errors["callback_time"]
                                ? _c("booking-element-error", {
                                    key: _vm.i,
                                    attrs: { type: "error", msg: msg },
                                  })
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "column small-12 large-6" },
                          [
                            _c("label", [
                              _vm._v("Anmerkung zur Kontaktaufname:"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.callback_comment,
                                  expression: "form.callback_comment",
                                },
                              ],
                              staticClass: "underline",
                              attrs: { type: "text" },
                              domProps: { value: _vm.form.callback_comment },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "callback_comment",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.form.callback_time == 1
                              ? [
                                  _c("label", [
                                    _vm._v("Gewünschter Zeitpunkt:"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.callback_info,
                                        expression: "form.callback_info",
                                      },
                                    ],
                                    staticClass: "underline",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.callback_info },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.form,
                                          "callback_info",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.errors["callback_info"],
                                    function (msg) {
                                      return _vm.errors["callback_info"]
                                        ? _c("booking-element-error", {
                                            key: _vm.i,
                                            attrs: { type: "error", msg: msg },
                                          })
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.callbackDetailsText
                                      ),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "column small-12 large-12" }, [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.callbackText) },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      class: { "booking-error": _vm.hasErrors },
                    },
                    [
                      _c("label", [
                        _c("b", [_vm._v("Weitere Services")]),
                        _vm.hasFlight
                          ? _c("b", [_vm._v("/Flugreservierung")])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "column small-12 large-12" },
                          [
                            _c("label", [
                              _vm._v(
                                "Gewünschte Serviceleistungen (Mehrfachauswahl):"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("select2", {
                              attrs: {
                                options: _vm.mappedServiceOptions,
                                settings: {
                                  placeholder: "Bitte wählen Sie:",
                                  dropdownCssClass: "dropdown-shadow",
                                  multiple: true,
                                },
                              },
                              model: {
                                value: _vm.form.services,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "services", $$v)
                                },
                                expression: "form.services",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasFlight
                        ? _c(
                            "div",
                            { staticClass: "row spacer" },
                            [
                              _c(
                                "div",
                                { staticClass: "column small-12 large-12" },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.form.flightReservationRequested =
                                            !_vm.form.flightReservationRequested
                                        },
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.form
                                                .flightReservationRequested,
                                            expression:
                                              "form.flightReservationRequested",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.form.flightReservationRequested
                                          )
                                            ? _vm._i(
                                                _vm.form
                                                  .flightReservationRequested,
                                                null
                                              ) > -1
                                            : _vm.form
                                                .flightReservationRequested,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a =
                                                _vm.form
                                                  .flightReservationRequested,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.form,
                                                    "flightReservationRequested",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.form,
                                                    "flightReservationRequested",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.form,
                                                "flightReservationRequested",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _c("label", [
                                        _vm._v("Flugreservierung gewünscht"),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.form.flightReservationRequested
                                    ? _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.flightText),
                                        },
                                      })
                                    : _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.noFlightReservationText
                                          ),
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.errors["travelling_persons"],
                                    function (msg) {
                                      return _vm.errors["travelling_persons"] &&
                                        _vm.form.flightReservationRequested
                                        ? _c("booking-element-error", {
                                            key: _vm.i,
                                            attrs: { type: "error", msg: msg },
                                          })
                                        : _vm._e()
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.flightPersonsRequired,
                                function (f, i) {
                                  return _vm.form.flightReservationRequested
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "column small-12 large-12",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row",
                                              class: {
                                                "booking-error":
                                                  _vm.form.travellingPersons[i]
                                                    .error,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column small-12 large-12",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(i + 1) + ". Person"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column small-12 large-2",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Anrede*"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("select2", {
                                                    attrs: {
                                                      options: _vm.genderSelect,
                                                      settings: {
                                                        placeholder:
                                                          "Bitte wählen Sie:",
                                                        dropdownCssClass:
                                                          "dropdown-shadow",
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form
                                                          .travellingPersons[i]
                                                          .gender,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ],
                                                          "gender",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.travellingPersons[i].gender",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column small-12 large-4",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Vorname*"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ].first_name,
                                                        expression:
                                                          "form.travellingPersons[i].first_name",
                                                      },
                                                    ],
                                                    staticClass: "underline",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value:
                                                        _vm.form
                                                          .travellingPersons[i]
                                                          .first_name,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ],
                                                          "first_name",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column small-12 large-3",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Nachname*"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ].last_name,
                                                        expression:
                                                          "form.travellingPersons[i].last_name",
                                                      },
                                                    ],
                                                    staticClass: "underline",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value:
                                                        _vm.form
                                                          .travellingPersons[i]
                                                          .last_name,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ],
                                                          "last_name",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column small-12 large-3",
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Geb.datum*"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ].date_of_birth,
                                                        expression:
                                                          "form.travellingPersons[i].date_of_birth",
                                                      },
                                                    ],
                                                    staticClass: "underline",
                                                    attrs: { type: "date" },
                                                    domProps: {
                                                      value:
                                                        _vm.form
                                                          .travellingPersons[i]
                                                          .date_of_birth,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.form
                                                            .travellingPersons[
                                                            i
                                                          ],
                                                          "date_of_birth",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e()
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "booking-element",
                      class: { "booking-error": false },
                    },
                    [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              _vm.form.privacyCheck = !_vm.form.privacyCheck
                            },
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.privacyCheck,
                                expression: "form.privacyCheck",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.form.privacyCheck)
                                ? _vm._i(_vm.form.privacyCheck, null) > -1
                                : _vm.form.privacyCheck,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.form.privacyCheck,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "privacyCheck",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "privacyCheck",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "privacyCheck", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "Mit dem Absenden des Formulars bestätige ich, die "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/de/datenschutz",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "Datenschutzerklärungen von Luxurydreams"
                                ),
                              ]
                            ),
                            _vm._v(
                              " gelesen, verstanden und aktzepiert zu haben."
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "a",
                          {
                            staticClass: "cta cta--inline",
                            on: {
                              click: function ($event) {
                                return _vm.submitOfferRequest()
                              },
                            },
                          },
                          [_vm._v("Reisewunsch absenden")]
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _c("loader", {
            attrs: {
              title: "Ihre Buchung wird vorbereitet",
              details: "Einen Moment bitte",
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }